module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-right.084c0840.svg";